import { ALL_ACTIONS } from '../../constants';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const withPermission = (WrappedComponent: React.ComponentType<any>, requiredAction: ALL_ACTIONS) => {
	const ComponentWithPermission = (props: any) => {
		const allowedActions = useSelector((state: RootState) => state.roleState.data.allowedActions);
		if (!allowedActions.includes(requiredAction)) {
			return null;
		}

		return <WrappedComponent {...props} />;
	};

	ComponentWithPermission.displayName = `WithPermission(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

	return ComponentWithPermission;
};

export default withPermission;